import React, { Fragment, useState, useContext, useEffect } from 'react';

import {
    Grid,
    TextField,
    Button,
    Typography,
    Paper,
    Box
} from '@material-ui/core';

import Alert from '@material-ui/lab/Alert';
import { useStyles } from '../styles/CardStyles';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import NotificationContext from '../context/Notification/notificationContext';
import OTP from '../components/OTP/OTP';
import Notification from '../components/notification/Notification';
import Spinner from '../components/spinner/Spinner';
import NumberFormat from 'react-number-format';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Header from '../components/header/Header';
import ReCAPTCHA from "react-google-recaptcha";

const ActivateCardMobileNumber = () => {
    const classes = useStyles(); //Use Styles from styles/styles.js
    const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
    const notificationContext = useContext(NotificationContext);
    const {
        errors,
        clearErrors,
        loading,
        setAtmCardNumberDetails,
        cardValidationMobileNumber,
        atmCardNumberDetails
    } = documentUploadContext;

    const [mobileNumber, setMobileNumber] = useState('');
    const onMobileNumberChange = (e) => setMobileNumber(e.target.value);
    const [inlineErrorMessage, setInlineErrorMessage] = useState('');
    const handleSubmitClick = (e) => {
        if (mobileNumber == '')
        {
            setInlineErrorMessage('Please input your mobile number');
        }
        else {
            cardValidationMobileNumber(atmCardNumberDetails, mobileNumber, 4);
        }
    };

    useEffect(() => {
        if (errors != null) {
            notificationContext.setNotification(errors, 'error');
        }

    }, [errors]);

    return (
        <div>
            <Header page={2} />
            <div className={classes.banner}>
                <Typography className={classes.paragraph}>
                    In order to proceed with your Flexi Card activation, please enter your mobile number in order to proceed.
                </Typography>
                <Fragment>
                    <Paper elevation={0} className={classes.paper}>
                    <Notification/>
                        {
                            errors != null ? <Alert severity='error' >You have provided an invalid link. Please click on the button below to go back to our website home page. Thank you.</Alert> : null
                        }
                        {loading ? (
                            <Spinner />
                        ) : (
                                <Fragment>
                                    {
                                        errors != null ?
                                        <Grid container item alignItems='center' justify='center'>
                                            <Grid item md={3}>
                                                <Button item className={classes.button} variant='contained' color='primary' href='/'> Back to Home Page</Button>
                                            </Grid>
                                        </Grid> :
                                        
                                        <Grid container direction='row' spacing={3}>
                                        <Grid container md={12} item>
                                            <p classes={classes.txtFldLbl}>Input your mobile number</p>
                                                <TextField
                                                    className={classes.txtField}
                                                    name='mobileNumber'
                                                    autoComplete='off'
                                                    id='mobileNumber'
                                                    variant='outlined'
                                                    type='text'
                                                    InputLabelProps={{ required: true }}
                                                    value={mobileNumber}
                                                    onChange={onMobileNumberChange}
                                                    placeholder=""
                                                    inputProps={{ maxLength: 11 }}
                                                    InputProps={{
                                                        inputComponent: NumberFormat,
                                                    }}>
                                                </TextField>
                                        </Grid>
                                        <Grid container direction='column' item>                            
                                        <Grid container item alignItems='center' justify='center'>
                                            <Grid item md={4}>
                                                <Typography align='center'>
                                                    <div className={classes.inlineErrorMessage}>{inlineErrorMessage}</div>
                                                </Typography>  
                                            </Grid>
                                        </Grid>
                                        <Grid container item alignItems='center' justify='center'>
                                            <Grid item md={3} sm={4} xs={4}>
                                                <Button className={classes.button} variant='contained' color='primary' type='submit' onClick={handleSubmitClick}>Proceed</Button>
                                            </Grid>
                                        </Grid>
                                        </Grid>
                                        </Grid>
                                    }  
                                </Fragment>
                            )}
                    </Paper>
                </Fragment>
            </div>  
        </div>
    );
};

export default ActivateCardMobileNumber;
